import React from 'react';
import { Typography } from '@mui/material';
import { Variant } from '@mui/material/createTypography';
import TooltipContentProps from './TooltipContent.props';

export const TooltipContent = ({title, defaultText, customText}: TooltipContentProps) => {
  const titleVariant = {variant: 'h6' as Variant, style: {fontSize: '12px !important'}};
  const bodyVariant = 'body1';
  return (
    <>
      <Typography {...titleVariant}>{title}</Typography>
      <br/>
      <Typography {...titleVariant}>Default (unselected)</Typography>
      <Typography variant={bodyVariant}>{defaultText}</Typography>
      <br/>
      <Typography {...titleVariant}>Custom (selected)</Typography>
      <Typography variant={bodyVariant}>{customText}</Typography>
    </>
  );
};